import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { cn } from '@bem-react/classname'
import parse from 'html-react-parser'

import { VerifyCode } from '@/components/Form/VerifyCode'
import { Tag } from '@/components/UI/Tag'

import { RegisterCodePhoneModel } from '../../models/Register.model'
import './PhoneCodeStep.scss'

interface IPhoneCodeStepProps {
  className?: string
  onCompleted?: () => void
  value?: string
}

const cnPhoneCodeStep = cn('PhoneCodeStep')

export const PhoneCodeStep: FC<IPhoneCodeStepProps> = ({
  className,
  onCompleted,
  value,
}) => {
  const { t } = useTranslation()

  const {
    control,
    formState: { errors },
  } = useFormContext<RegisterCodePhoneModel>()

  const onHandleChange = (value: string) => {
    if (value.length === 6 && onCompleted) onCompleted()
  }

  return (
    <div className={cnPhoneCodeStep(null, [className])}>
      <Tag className={cnPhoneCodeStep('title')}>{t('register-six-title')}</Tag>

      {value && (
        <div className={cnPhoneCodeStep('text')}>
          {parse(
            t('register-six-text', {
              email: 'test@test.ru',
            }),
          )}
        </div>
      )}

      <Controller
        name='phone_code'
        control={control}
        render={({ field: { onChange } }) => (
          <VerifyCode
            placeholder=''
            onChange={value => {
              onChange(value)
              onHandleChange(value)
            }}
            errors={errors.phone_code?.message}
            autoFocus
            // onCompleted={onCompleted}
          />
        )}
      />
    </div>
  )
}
